export const LookerAPIRoutes = {
  alterEmbedAccess: () => `/v5/looker/alter_embed_access`,

  // Query + suggestions (already backend-proxied on main).
  executeQuery: () => '/v7/looker/execute',
  getSuggestions: () => '/v7/looker/suggestions',

  // Cookieless embed session (backend proxies to Looker /embed/cookieless_session/*).
  acquireEmbedSession: () => '/v7/looker/embed/acquire_session',
  generateEmbedTokens: () => '/v7/looker/embed/generate_tokens',

  // User info (backend proxies sdk.me / sdk.user_attribute_user_values).
  me: () => '/v7/looker/user/me',
  userAttributes: () => '/v7/looker/user/attributes',

  // Dashboards (backend resolves LookML slug and forwards to Looker).
  dashboardFilters: (slug: string) => `/v7/looker/dashboards/${encodeURIComponent(slug)}/filters`,
  importDashboardLookML: () => '/v7/looker/dashboards/import_lookml',
};
